// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"121":"component---src-templates-blog-list-js","751":"component---src-templates-blog-post-js"}[chunkId] + "-" + {"121":"9d7545bdf7f94713a1d7","751":"1e1183d7ed7e44b7dbaa"}[chunkId] + ".js";
};